import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'invokeAgent',
  agentId: '',
  analyticsAgentId: '',
  message: '',
  conversationId: '',
  division: 'Evo',
  product: '',
  organisationId: '',
  userId: '',
  additionalContext: '',
  attachments: '',
  startDate: '',
  endDate: '',
};

export default defaults;
